import { CustomerContractRole } from '@ekt-group/general-purpose-api-interfaces/src/types/customer-contract-role.enum';

export const DATE_FORMAT = 'DD.MM.YYYY'
export const ROLES_TO_CONFIRM_CONTACT_INFORMATION_POPUP = [
  CustomerContractRole.ContractOwner,
  CustomerContractRole.AuthorisedPerson,
  CustomerContractRole.CompanyRepresentative,
  CustomerContractRole.ParentContract
]
export const CONTACT_INFORMATION_VALIDATION_INTERVAL_IN_MONTHS = 6;
